module.exports = __webpack_public_path__ + "static/media/vip_title_0.b86e4cd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vip_title_0.jpg
// module id = 1407
// module chunks = 0